module.exports = "/images/bannerThree.jpg";